import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { BiUserPlus } from 'react-icons/bi';

let AssignButton = (props) => {
    return (
        <IconButton 
            aria-label="Download"
            onClick={() => props.onClick()}
        >
            <BiUserPlus />
        </IconButton>
    );
}

export default AssignButton;

  